<template>
  <div
    class="size-12 animate-spin rounded-full border-4 border-gray-100 !border-t-teal-500 dark:border-gray-600"
  ></div>
</template>
